import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";

const SectionReveal = ({ children, id, className = "" }) => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.05 });

  return (
    <div
      ref={ref}
      id={id}
      className={`section-reveal ${isVisible ? "section-entered" : ""} ${className}`}
    >
      <div className="sr-line sr-line-top" />
      <div className="sr-line sr-line-bottom" />
      {children}
    </div>
  );
};

export default SectionReveal;
